import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-carousel--next",
  "use": "icon-carousel--next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-carousel--next\"><path d=\"M.934 10.954v2.18h21.793v-2.18H.934Z\" fill=\"currentColor\" /><path d=\"M22.392 10.503 10.834 22.06l1.541 1.541 11.558-11.557-1.541-1.541Z\" fill=\"currentColor\" /><path d=\"m12.375.487-1.54 1.54 11.557 11.558 1.54-1.541L12.376.487Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol